import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getConfig } from '../../config';
export const LoginView = () => {
    const { loginWithRedirect } = useAuth0();
    const location = useLocation();
    const navigate = useNavigate();
    const config = getConfig();
    // Extract query parameters
    const queryParams = new URLSearchParams(location.search);
    const invitation = queryParams.get('invitation');
    const organization = queryParams.get('organization');
    // const organizationName = queryParams.get('organization_name');
    // console.log('Invitation:', invitation);
    // console.log('Organization:', organization);
    // console.log('Organization Name:', organizationName);
    // console.log(`Encoded Redirect URI: ${encodeURIComponent(window.location.origin)}`);
    // console.log(`Redirect URI: ${window.location.origin}`);
    // console.log('Audience:', config.audience ? config.audience : null);
    // If already authenticated, redirect to home page
    useEffect(() => {
        if (invitation && organization) {
            loginWithRedirect({
                authorizationParams: {
                    audience: config.audience ? config.audience : null,
                    invitation: invitation,
                    organization: organization,
                    redirect_uri: window.location.origin,
                    scope: 'openid email profile offline_access',
                },
            });
        }
        else {
            navigate('/');
        }
    }, []);
    return React.createElement("p", null, "Redirecting to login...");
};
export default LoginView;
